import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { ActionFailed } from './utility.actions'
import { tap } from 'rxjs/operators'
import { Toaster } from '@tokeet/tv3-platform'
import { HttpErrorResponse } from '@angular/common/http'

declare const window: any

@Injectable()
export class UtilityEffects {
  @Effect({ dispatch: false })
  actionFailed$ = this.actions$.pipe(
    ofType(ActionFailed),
    tap((action) => {
      // @ts-ignore
      const error = action instanceof HttpErrorResponse ? action : action.error || action.payload
      const role = localStorage.getItem('tv3:USER_ROLE')
      // tslint:disable-next-line:triple-equals
      if (!action.skip401 && /READ-ONLY/.test(role) && error?.status == 401) {
        return
      }
      if (window.navigator.onLine) {
        this.toast.error($localize`Something went wrong`, null, error)
      } else {
        this.toast.error('Error', null, $localize`Please check your internet connection.`)
      }
    })
  )

  constructor(private actions$: Actions, private toast: Toaster) {}
}
